import { BaseDto } from "../base/baseDto.model";

export class LocalidadBasicDto{
    public id :number =0;
    public descripcion:string ="" 
    public provincia: BaseDto = new BaseDto
}